"use client";

import React, { createContext, useContext, useState, ReactNode } from 'react';

interface NavContextType {
  hideMainNavItems: boolean;
  setHideMainNavItems: (hide: boolean) => void;
}

const NavContext = createContext<NavContextType>({
  hideMainNavItems: false,
  setHideMainNavItems: () => {},
});

export const useNav = () => useContext(NavContext);

interface NavProviderProps {
  children: ReactNode;
}

export function NavProvider({ children }: NavProviderProps) {
  const [hideMainNavItems, setHideMainNavItems] = useState(false);

  return (
    <NavContext.Provider value={{ hideMainNavItems, setHideMainNavItems }}>
      {children}
    </NavContext.Provider>
  );
}